<template>
	<div class="d-flex" style="height: 100dvh; overflow: hidden">
		<div
			class="app-animated-background"
			:style="'background-image: url(' + appOptions.backgroundUrlExtern + ');'"
		></div>

		<div class="d-flex flex-column justify-content-center w-100 h-100">
			<div class="container container-max-xl p-3 flex-grow-1 align-self-center d-flex justify-content-center">
				<div class="card align-self-center">
					<div class="card-body">
						<router-view />
					</div>
				</div>
			</div>
			<!--<div class="d-flex justify-content-end pb-1">
				<a
					href="https://www.hetzner.com/de/unternehmen/nachhaltigkeit/"
					target="_blank"
					rel="noopener noreferrer"
				>
					<img
						src="/img/logos-brands/hetzner-green-energy.svg"
						alt="Powered by Hetzner Green Energy"
						style="height: 128px; opacity: 0.85"
				/></a>
			</div>-->
			<div class="d-flex justify-content-between" style="background: rgba(52, 58, 64, 0.5)">
				<span class="text-white p-2">
					<a class="text-white" href="https://www.etherforce.net" target="_blank" rel="noopener noreferrer"
						>&copy;&nbsp;etherforce GmbH</a
					>
				</span>
				<span class="d-flex flex-wrap justify-content-end text-white p-2">
					<div><a class="text-white" href="/privacy">Datenschutz</a>&nbsp;&#8729;&nbsp;</div>
					<div><a class="text-white" href="/legal">Impressum</a>&nbsp;&#8729;&nbsp;</div>
					<div><a class="text-white text-nowrap" href="/disclosure">Responsible Disclosure</a></div>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useAppOptionsStore } from '../../stores/app-options';

const appOptions = useAppOptionsStore();
</script>

<style scoped lang="scss">
div.app-animated-background {
	--app-animated-background-color: black;
	--app-animated-background-opacity: 50%;

	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;
	animation: zoomin 6s linear;
	-webkit-animation: zoomin 6s linear;
	animation-fill-mode: forwards;
	animation-delay: 1s;

	position: relative;
	width: 100%;
	height: 100%;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: var(--app-animated-background-color);
		opacity: var(--app-animated-background-opacity);
	}

	& + div {
		position: absolute;
	}
}

@keyframes zoomin {
	0% {
		-webkit-transform: scale(1);
		transform: scale(1);
	}
	100% {
		-webkit-transform: scale(1.2);
		transform: scale(1.2);
	}
}
</style>
